import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {
    const [wishlist, setWishlist] = useState([]);

    // Encrypt Data
    const encryptData = (data) => {
        try {
            let jsonString = JSON.stringify(data);
            let encryptedString = btoa(
                jsonString
                    .split("")
                    .map(char => String.fromCharCode(char.charCodeAt(0) + 3))
                    .join("")
            );
            return encryptedString;
        } catch (error) {
            console.error("Encryption error:", error);
            return "";
        }
    };

    // Decrypt Data
    const decryptData = (encryptedData) => {
        try {
            let decodedString = atob(encryptedData);
            let decryptedString = decodedString
                .split("")
                .map(char => String.fromCharCode(char.charCodeAt(0) - 3))
                .join("");
            return JSON.parse(decryptedString);
        } catch (error) {
            console.error("Decryption error:", error);
            return [];
        }
    };

    // Load wishlist from local storage on mount
    useEffect(() => {
        const storedWishlist = localStorage.getItem("wishlist");
        if (storedWishlist) {
            setWishlist(decryptData(storedWishlist));
        }
    }, []);

    // Save wishlist to local storage (encrypted)
    const saveWishlist = (wishlistData) => {
        localStorage.setItem("wishlist", encryptData(wishlistData));
    };

    // Add to Wishlist
    const addToWishlist = (item) => {
        setWishlist((prevWishlist) => {
            if (!prevWishlist.some(wishItem => wishItem.id === item.id)) {
                const updatedWishlist = [...prevWishlist, item];
                saveWishlist(updatedWishlist);
                toast.info("Product add to wishList successfully!")
                return updatedWishlist;
            }
            return prevWishlist;
        });
    };

    // Remove from Wishlist
    const removeFromWishlist = (productId) => {
        setWishlist((prevWishlist) => {
            const updatedWishlist = prevWishlist.filter(item => item.id !== productId);
            saveWishlist(updatedWishlist);
            return updatedWishlist;
        });
    };

    return (
        <WishlistContext.Provider value={{ wishlist,setWishlist, addToWishlist, removeFromWishlist }}>
            {children}
        </WishlistContext.Provider>
    );
};

export const useWishlist = () => useContext(WishlistContext);
